import { Routes } from "@angular/router";
import { DailyFeedbackReportsPageComponent } from "./daily-feedback-reports-page.component";
import { authGuard } from "../../../core/guards/auth.guard";

export const dailyFeedbackReportsPageRoutes: Routes = [
  {
    path: 'records/daily-feedback-reports',
    component: DailyFeedbackReportsPageComponent,
    canActivate: [authGuard]
  }
]
